import { CheckConnection, Header } from "./components";
import { Settings } from "./components/Settings";
import { SuiteSection } from "./components/SuiteSection";
import { STORE_API_METHODS } from "./constants/methods";
import { useSetupApp } from "./hooks/useSetupApp";
import { Widgets } from "./suites";
import { Box, useTheme } from "@mui/material";

function App() {
  const theme = useTheme();
  useSetupApp();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
      }}
    >
      <Header />
      <Settings />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "center",
          padding: theme.custom.bigGutterMargin,
        }}
      >
        <SuiteSection
          title="Connection Suite"
          methods={STORE_API_METHODS.CONNECTION_SUITE}
          startSlot={<CheckConnection />}
        />
        <SuiteSection title="Private Read Suite" methods={STORE_API_METHODS.PRIVATE_READ_SUITE} />
        <SuiteSection title="Public Read Suite" methods={STORE_API_METHODS.PUBLIC_READ_SUITE} />
        <SuiteSection title="Write Suite" methods={STORE_API_METHODS.WRITE_SUITE} />
        <Widgets />
      </Box>
    </Box>
  );
}

export default App;
